import React from 'react'
import styled from 'styled-components'

const Container = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  border: 1px solid black;
`

const EventCard = ({ event }) => {
  return <Container>{event?.title}</Container>
}

export default EventCard
